module.exports = __webpack_public_path__ + "img/ic-app.0f48f73b.svg";